import { Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';

@InjectModule({ stateFactory: true }, module)
export default class PathModule extends InjectVuexModule {
    path = '';
    loginPath = '';

    @Mutation
    setPath(path: 'enroll' | 'portal-login' | 'provider' | 'patient-search' | 'enroll-new-patient' | 'pharmacy' | 'hcp') {
        localStorage.setItem('madrigal-path', path)
        this.path = path;
    }

    @Mutation
    setLoginPath(loginPath: 'mps-login' | '') {
        localStorage.setItem('loginPath-path', loginPath)
        this.loginPath = loginPath;
    }

    @Mutation
    clearPath() {
        this.path = '';
        this.loginPath = '';
        localStorage.setItem('loginPath-path', '')
    }
}